import Axios from '../utils/union-axios'

/**
 * 获取当前用户积分余额
 */
export function GetUserCredit() {
  return Axios.get(`/web-h5/charge/getUserCredit`)
}

/**
 * 在普通浏览器端static域名拿不到chargegateway域名的cookie，即无法获取到uid
 * 这里做一个特殊处理，若在APP/小程序环境内，拿联登sdk处理时传入的preUid作为当前用户uid，在普通浏览器内使用接口获取uid
 */
function GetCurrentUser() {
  return Axios.get(`/web-h5/charge/member/getCurrentUser`)
}
export const getCurrentUid = () => {
  return new Promise<any>((resolve) => {
    const sessionUid = sessionStorage.getItem('sessionUid') || ''
    if (sessionUid) {
      resolve(sessionUid)
    } else {
      GetCurrentUser().then(res => {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          resolve('')
        }
      }).catch(err => {
        resolve('')
      })
    }
  })
}